module.exports = __webpack_public_path__ + "static/media/buy_request_details_make_4-1.c563e917.png";